const apiConfig = {
    // apiUrl: "http://localhost:7900/api"
    // apiUrl: "http://192.168.0.83:7900/api"
    apiUrl: "https://api.skilltechlms.cloud/api"
};

export default apiConfig;
